import { MockRouteEntry } from '../mock-api.types';
import { HRM_MOCK_HANDLERS } from './hrm.fixtures';
import { ACCOUNTING_MOCK_HANDLERS } from './accounting.fixtures';
import { PAYROLL_MOCK_HANDLERS } from './payroll.fixtures';
import { PMS_MOCK_HANDLERS } from './pms.fixtures';
import { BILLING_MOCK_HANDLERS } from './billing.fixtures';
import { WEBSITE_MOCK_HANDLERS } from './website.fixtures';
import { MARKETING_MOCK_HANDLERS } from './marketing.fixtures';
import { WALLET_MOCK_HANDLERS } from './wallet.fixtures';
import { AI_MOCK_HANDLERS } from './ai.fixtures';
import { CAMPAIGN_MOCK_HANDLERS } from './campaign.fixtures';
import { PLATFORM_MOCK_HANDLERS } from './platform.fixtures';
import { SUPPORT_MOCK_HANDLERS } from './support.fixtures';
import { DMS_MOCK_HANDLERS } from './dms.fixtures';
import { STORE_MOCK_HANDLERS } from './store.fixtures';
import { MAILING_MOCK_HANDLERS } from './mailing.fixtures';

export const MOCK_ROUTE_REGISTRY: MockRouteEntry[] = [
    ...PLATFORM_MOCK_HANDLERS,
    ...CAMPAIGN_MOCK_HANDLERS,
    ...HRM_MOCK_HANDLERS,
    ...ACCOUNTING_MOCK_HANDLERS,
    ...PAYROLL_MOCK_HANDLERS,
    ...PMS_MOCK_HANDLERS,
    ...BILLING_MOCK_HANDLERS,
    ...WEBSITE_MOCK_HANDLERS,
    ...MARKETING_MOCK_HANDLERS,
    ...WALLET_MOCK_HANDLERS,
    ...AI_MOCK_HANDLERS,
    ...DMS_MOCK_HANDLERS,
    ...SUPPORT_MOCK_HANDLERS,
    ...STORE_MOCK_HANDLERS,
    ...MAILING_MOCK_HANDLERS,
];
